module.exports = __webpack_public_path__ + "media/audio21.48fc9841.mp3";